import {axios as http} from "@/plugins/http"

export default class Api {
    static orders(ids, typeId) {
        return http.post("/api/v1/statistic/posts", {
            post_id: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }

    static chainOrders(ids, typeId) {
        return http.post("/api/v1/statistic/posts-chain", {
            post_id: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }
}
